import zxcvbn from 'zxcvbn'
import { PasswordScoreEnum } from '@/constants/password-score.constants'
export function validatePassword (value) {
  if (value === '') {
    return {
      score: 'None',
      error: new Error('Please input the password')
    }
  } else {
    if (value.length < 8 || value.length > 64) {
      return {
        score: 0,
        error: new Error(
          `Your password needs to be between 8-64 characters long.`
        )
      }
    } else {
      let passwordCheck = zxcvbn(value)
      if (passwordCheck.score < 3) {
        return {
          score: passwordCheck.score,
          error: new Error(
            `${PasswordScoreEnum[passwordCheck.score]} Password${
              passwordCheck.feedback.warning
                ? ': ' + passwordCheck.feedback.warning
                : ''
            }`
          )
        }
      } else {
        return {
          score: passwordCheck.score,
          error: false
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utilities/user/validation.js